import { Directive, computed, input } from '@angular/core';
import { optimizedImage } from '../../media/optimized-image';

@Directive({selector: 'img[appOptimizedImage]', standalone: true, host: {
  '[src]': 'asset()?.src || src()', '[attr.srcset]': 'asset()?.srcset || null',
  '[attr.sizes]': 'imageSizes()', '[attr.width]': 'asset()?.width || null',
  '[attr.height]': 'asset()?.height || null',
}})
export class OptimizedImageDirective {
  readonly src = input<string | null | undefined>();
  readonly imageSizes = input('170px');
  protected readonly asset = computed(() => optimizedImage(this.src()));
}
